/**
 * Who may open admin.posture.vision: SUPER_ADMIN and nobody else. pv-auth
 * enforces the same on every /provider/admin/* feed the console reads, so
 * this list only decides what renders; it can never widen access.
 */
export const CONSOLE_ROLES = ['SUPER_ADMIN'] as const;

export const isConsoleRole = (role: unknown): role is (typeof CONSOLE_ROLES)[number] =>
  typeof role === 'string' && (CONSOLE_ROLES as readonly string[]).includes(role);

/** Where the consumer app lives, for the exit link and the deep links. */
export const APP_URL = 'https://www.posture.vision';
export const STATUS_URL = 'https://www.posture.vision/status';
export const ATLAS_URL = 'https://marketing.posture.vision';
